<template>
  <header
    class="fixed inset-x-0 top-0 z-[100] border-b border-border-subtle bg-[rgba(249,246,240,0.8)] backdrop-blur-md"
  >
    <div
      class="mx-auto grid h-[72px] max-w-page grid-cols-[1fr_auto_1fr] items-center px-6 lg:px-10"
    >
      <div class="justify-self-start">
        <router-link
          to="/#header"
          class="font-interface text-base font-medium uppercase tracking-[0.2em] text-text-primary transition-colors duration-cinematic ease-luxury hover:opacity-80"
        >
          SNAPSHARE
        </router-link>
      </div>

      <nav class="flex items-center justify-center gap-10">
        <SiteHeaderLink
          v-for="link in navLinks"
          :key="link.url"
          :link="link"
        />
      </nav>

      <div class="justify-self-end">
        <LuxuryButton
          v-if="ctaLink"
          variant="compact"
          size="md"
          :to="ctaLink.url"
        >
          {{ ctaLink.text }}
        </LuxuryButton>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SiteHeaderLink from './SiteHeaderLink.vue';
import LuxuryButton from '@/components/library/buttons/LuxuryButton.vue';
import { buildSiteNavigation } from '@/composables/useSiteNavigation';
import { IUserInfo } from '@/helpers/interfaces';

export default defineComponent({
  name: 'SiteHeader',

  components: {
    SiteHeaderLink,
    LuxuryButton,
  },

  computed: {
    user(): IUserInfo | null {
      return this.$store.getters['user/getUser'];
    },

    hasActiveEvent(): boolean {
      return this.$store.getters['event/hasActiveEvent'];
    },

    navigation() {
      return buildSiteNavigation(this.user, this.hasActiveEvent);
    },

    navLinks() {
      return this.navigation.navLinks;
    },

    ctaLink() {
      return this.navigation.ctaLink;
    },
  },
});
</script>
